import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCbfmyAmHksiUGw4XxfzmVVwgYP4G4Ll2U",
  authDomain: "chrysalis-main.firebaseapp.com",
  projectId: "chrysalis-main",
  storageBucket: "chrysalis-main.firebasestorage.app",
  messagingSenderId: "659701191144",
  appId: "1:659701191144:web:e34156affd510b2e55545d",
};

// ✅ Initialize Firebase
export const app = initializeApp(firebaseConfig);

// ✅ Initialize Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
